import { Button, Col, H2, H3, JourneyButton, P, Row, Section } from '@ahmdigital/ui';
import { FC } from 'react';
import { map } from 'lodash/fp';
import styled from 'styled-components';

import { UrlObject } from '../../../../types/__codegen__/sanity/graphql';

const RelatedQuestionsSection = styled(Section)`
  text-align: center;
  padding: 4rem 0 3rem;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 5.5rem 0 3rem;
  }

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 7.5rem 0.25rem 6.5rem;
  }
`;

const LinkRow = styled(Row)`
  padding: 1rem 0;
  margin: auto;
  max-width: 70rem;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 2.25rem 0;
  }
`;

const LinkCol = styled(Col)`
  padding: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 0.75rem;
  }
`;

const LinkButton = styled(JourneyButton)`
  text-align: left;
  padding: 1.5rem;
  height: 100%;
  max-width: 100%;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 2rem;

    &:hover {
      padding: calc(2rem - 1px);
    }
  }
`;

const HelpButton = styled(Button)`
  margin-top: 1rem;
  height: 3.5rem;
  padding: 1.125rem;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    margin-top: 1.25rem;
  }
`;

const Question = styled(P)`
  margin: 0;
  font-size: 16px;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    font-size: 20px;
  }
`;

export type RelatedQuestionsProps = Readonly<{
  cta?: {
    title: string;
    to: string;
  };
  links: ReadonlyArray<
    {
      disabled?: boolean;
      inNewTab?: boolean;
    } & UrlObject
  >;
  subHeading?: JSX.Element;
}>;

const RelatedQuestions: FC<RelatedQuestionsProps> = ({ cta, links, subHeading }) => (
  <RelatedQuestionsSection variant={['regular', 'marginBottomSpacer10']}>
    <H2 variant="marginBottomSpacer9">Related questions</H2>
    {subHeading && (
      <H3 looksLike="h5" variant={['regular', 'marginBottomSpacer10']}>
        {subHeading}
      </H3>
    )}
    <LinkRow>
      {map(
        ({ disabled, inNewTab, name, url }) => (
          <LinkCol key={name} df={6} sm={12}>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
            <LinkButton to={url} disabled={disabled} inNewTab={inNewTab}>
              <Question looksLike="h5" data-testid="question">
                {name}
              </Question>
            </LinkButton>
          </LinkCol>
        ),
        links,
      )}

      {cta && (
        <LinkCol df={3} sm={12}>
          <HelpButton variant={['wide', 'black']} to={cta.to} role="button">
            <P looksLike="h6">{cta.title}</P>
          </HelpButton>
        </LinkCol>
      )}
    </LinkRow>
  </RelatedQuestionsSection>
);

export default RelatedQuestions;
